module.exports = __webpack_public_path__ + "static/media/36-13.4fe6c5ff.mp3";